<section>
    <div class="container">
        <!---------- Title ---------->
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="sec-heading2 center  mb-3">
                    <div class="sec-left">
                        <h2>Properties Of {{pageName}}</h2>
                        <p>
                            <!--Find new & featured property for you.-->
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!---------- Title ---------->
        <div class="row">
            <div class="col-lg-4 col-md-3 col-sm-6" *ngFor="let property of properties">
                <app-property-card [data]="property"></app-property-card>
            </div>
        </div>
        <!-- loadmore future -->
        <!-- <div class="row" #propertiesSection style="overflow: scroll; height: 1000px;" (scroll)="scrollHandler($event)">
            <div class="col-lg-4 col-md-3 col-sm-6" *ngFor="let property of properties">
                <app-property-card [data]="property"></app-property-card>
            </div>
        </div> -->
    </div>
</section>
<!---------- Featured Listings End ---------->

<!---------- North Bloomfield Properties Michigan’s Start ---------->
<!-- <section class="find-property-css mb-5" style="background-color: #f7f5f5;">
    <div class="container">
        <div class="sec-heading2 center  mb-3">
            <div class="sec-center" style="text-align:center;width:100%;">
                <h1 class="h2" style="color:#000;font-weight:600;">{{pageTitle}}</h1>
            </div>
        </div> -->
        <!-- row Start -->
        <!-- <div [innerHtml]=" pageContent | safe: 'html'"></div> -->
        <!-- <div class="find-by-city-page-button mt-4 text-center">
            <a href="#" class="btn btn-theme" role="button" aria-pressed="true">Primary link</a>    
        </div> -->
    <!-- </div>
</section> -->
<!---------- Find Properties By Cities Start ---------->
<section class="pt-0">
    <app-city-finder [data]="propertyByCities"></app-city-finder>
</section>
<!---------- Find Properties By Cities End ---------->

